import ih from 'immutability-helper';
import _omit from 'lodash/omit';

import * as types from './actionTypes';
import initialState from './initialState';
import { LOGOUT_USER_SUCCESS } from '../session/actionTypes';

const projectReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_PURGE_PROJECTS_REQUEST:
      return ih(state, {
        purge: {
          $merge: {
            isLoading: true,
            isOpen: true,
          },
        },
      });
    case types.GET_PURGE_PROJECT_SUCCESS:
      return ih(state, {
        purge: {
          $merge: {
            isLoading: false,
            data: action.payload.purgeList,
          },
        },
      });
    case types.GET_PURGE_PROJECT_ERROR:
      return ih(state, {
        purge: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.CLOSE_PURGE_MODAL:
      return ih(state, {
        purge: {
          $merge: {
            isOpen: false,
            data: {},
          },
        },
      });
    case types.PURGE_PROJECT_REQUEST:
      return ih(state, {
        purge: {
          isPurging: { $set: true },
        },
      });
    case types.PURGE_PROJECT_SUCCESS:
      return ih(state, {
        purge: {
          $merge: {
            isPurging: false,
            isOpen: false,
            data: {},
          },
        },
      });
    case types.PURGE_PROJECT_ERROR:
      return ih(state, {
        purge: {
          $merge: {
            isPurging: false,
            isOpen: false,
            error: action.payload.error,
          },
        },
      });
    case types.GET_PROJECT_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_PROJECT_SUCCESS:
      return ih(state, {
        show: { $merge: { isLoading: false } },
      });
    case types.GET_PROJECT_ERROR:
      return ih(state, {
        show: { $merge: { isLoading: false, error: action.payload.error } },
      });
    case types.SELECT_PROJECT:
      return ih(state, {
        show: {
          data: { $set: action.payload.project },
        },
      });
    case LOGOUT_USER_SUCCESS:
      return ih(state, {
        show: {
          data: { $set: {} },
        },
      });
    case types.EXPORT_PROJECT_REQUEST:
      return ih(state, {
        export: {
          isLoading: { $set: true },
        },
      });
    case types.EXPORT_PROJECT_SUCCESS:
      return ih(state, {
        export: {
          isLoading: { $set: false },
        },
      });
    case types.EXPORT_PROJECT_ERROR:
      return ih(state, {
        export: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });

    case types.CANCEL_EXPORT_PROJECT:
      return ih(state, {
        export: {
          isLoading: { $set: false },
        },
      });

    case types.GET_GENERAL_PROJECT_SETTINGS_REQUEST:
      return ih(state, {
        settings: {
          general: {
            $set: {
              ...initialState.settings.general,
              isLoading: true,
            },
          },
        },
      });

    case types.GET_GENERAL_PROJECT_SETTINGS_SUCCESS:
      return ih(state, {
        settings: {
          general: {
            $merge: {
              isLoading: false,
              data: _omit(action.payload, ['projectName']),
            },
          },
        },
      });

    case types.GET_GENERAL_PROJECT_SETTINGS_ERROR:
      return ih(state, {
        settings: {
          general: {
            $merge: {
              isLoading: false,
              error: action.payload,
            },
          },
        },
      });

    case types.UPDATE_PROJECT_NAME_REQUEST:
      return ih(state, {
        settings: {
          updateName: {
            $merge: {
              isLoading: true,
              error: '',
            },
          },
        },
      });

    case types.UPDATE_PROJECT_NAME_SUCCESS:
      return ih(state, {
        show: {
          data: { $set: action.payload },
        },
        settings: {
          updateName: {
            $merge: {
              isLoading: false,
              error: '',
            },
          },
        },
      });

    case types.UPDATE_PROJECT_NAME_ERROR:
      return ih(state, {
        settings: {
          updateName: {
            $merge: {
              isLoading: false,
              error: action.payload,
            },
          },
        },
      });

    case types.GET_PROJECT_SNAPSHOTS_REQUEST:
      return ih(state, {
        settings: {
          snapshots: {
            list: {
              $merge: {
                isLoading: true,
                error: '',
                data: initialState.settings.snapshots.list.data,
              },
            },
          },
        },
      });

    case types.GET_PROJECT_SNAPSHOTS_SUCCESS:
      return ih(state, {
        settings: {
          snapshots: {
            list: {
              $merge: {
                isLoading: false,
                error: '',
                data: action.payload,
              },
            },
          },
        },
      });

    case types.GET_PROJECT_SNAPSHOTS_ERROR:
      return ih(state, {
        settings: {
          snapshots: {
            list: {
              $merge: {
                isLoading: false,
                error: action.payload,
              },
            },
          },
        },
      });

    case types.CREATE_PROJECT_SNAPSHOT_REQUEST:
      return ih(state, {
        settings: {
          snapshots: {
            create: {
              $merge: {
                isLoading: true,
                error: '',
              },
            },
          },
        },
      });
    case types.CREATE_PROJECT_SNAPSHOT_SUCCESS:
      return ih(state, {
        settings: {
          snapshots: {
            create: {
              $merge: {
                isLoading: false,
                error: '',
              },
            },
          },
        },
      });
    case types.CREATE_PROJECT_SNAPSHOT_ERROR:
      return ih(state, {
        settings: {
          snapshots: {
            create: {
              $merge: {
                isLoading: false,
                error: action.payload,
              },
            },
          },
        },
      });
    case types.DOWNLOAD_PROJECT_SNAPSHOTS_REQUEST:
      return ih(state, {
        settings: {
          snapshots: {
            download: {
              $merge: {
                isLoading: true,
                error: '',
              },
            },
          },
        },
      });

    case types.DOWNLOAD_PROJECT_SNAPSHOTS_SUCCESS:
      return ih(state, {
        settings: {
          snapshots: {
            download: {
              isLoading: { $set: false },
            },
          },
        },
      });

    case types.DOWNLOAD_PROJECT_SNAPSHOTS_ERROR:
      return ih(state, {
        settings: {
          snapshots: {
            download: {
              $set: { isLoading: false, error: action.payload },
            },
          },
        },
      });

    case types.DELETE_PROJECT_REQUEST:
      return ih(state, {
        delete: {
          isLoading: { $set: true },
        },
      });

    case types.DELETE_PROJECT_SUCCESS:
      return ih(state, {
        delete: {
          isLoading: { $set: false },
        },
        show: { $set: initialState.show },
      });

    case types.DELETE_PROJECT_ERROR:
      return ih(state, {
        delete: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });

    case types.ROLLBACK_PROJECT_REQUEST:
      return ih(state, {
        settings: {
          snapshots: {
            rollback: {
              $merge: {
                isLoading: true,
                error: '',
              },
            },
          },
        },
      });

    case types.ROLLBACK_PROJECT_SUCCESS:
      return ih(state, {
        show: {
          data: { $set: action.payload },
        },
        settings: {
          snapshots: {
            rollback: { isLoading: { $set: false } },
          },
        },
      });

    case types.ROLLBACK_PROJECT_ERROR:
      return ih(state, {
        settings: {
          snapshots: {
            rollback: {
              $set: { isLoading: false, error: action.payload },
            },
          },
        },
      });
    case types.INITIALIZE_VERSION_CONTROL_REQUEST:
      return ih(state, {
        settings: {
          versionControl: {
            $merge: { isLoading: true },
          },
        },
      });

    case types.INITIALIZE_VERSION_CONTROL_SUCCESS:
      return ih(state, {
        settings: {
          versionControl: {
            $merge: { isLoading: false },
          },
        },
      });

    case types.INITIALIZE_VERSION_CONTROL_ERROR:
      return ih(state, {
        settings: {
          versionControl: {
            $merge: { isLoading: false, error: action.payload.error },
          },
        },
      });

    case types.RESET_PROJECT_BRANCH:
      return ih(state, {
        show: {
          data: {
            project_branch: {
              $set: null,
            },
          },
        },
      });

    case types.UPDATE_PROJECT_BRANCH:
      return ih(state, {
        show: {
          data: {
            project_branch: {
              $set: action.payload,
            },
          },
        },
      });
    case types.ROLLBACK_PROJECT:
    default:
      return state;
  }
};

export default projectReducer;
